import React from "react";

export default function Access1({ className }) {
  return (
    <svg
      width="173"
      height="173"
      viewBox="0 0 173 173"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : ""}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.5903 46.368V11.84H110.774V156H72.5983V46.368H53.5903ZM74.5983 44.368V154H108.774V13.84H55.5903V44.368H74.5983Z"
        fill="url(#paint0_linear_20028_5840)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20028_5840"
          x1="86.5001"
          y1="-3.01902e-05"
          x2="86.5001"
          y2="173"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2E2AA" />
          <stop offset="0.520833" stopColor="#E8CA78" stopOpacity="0" />
          <stop offset="1" stopColor="#F2E2AA" />
        </linearGradient>
      </defs>
    </svg>
  );
}
